import React, { forwardRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Analytics } from 'lib/AnalyticsLoader/analytics';
import { audioManager } from 'lib/audio/audio-manager';
import { AUDIO_TYPES } from 'lib/audio/audio.types';

import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { InfoModal } from 'shared/components/ui/info-modal/info-modal';
import { useAccount, useSignMessage } from 'shared/hooks/use-web3';
import { useGlobalStore } from 'shared/store/globalStore';

import checklist from 'assets/png/checklist.png?format=webp;avif&as=picture';

export const SignModal = forwardRef<HTMLDivElement>((props, ref) => {
  const { t } = useTranslation();
  const [date, setDate] = React.useState<Date>();
  const { address, isConnecting } = useAccount();
  const { data: signMessageData, signMessage } = useSignMessage();
  const { setJwt, setJwtValidUntil } = useGlobalStore();

  useEffect(() => {
    if (signMessageData) {
      setJwt({ address, jwt: signMessageData });
      setJwtValidUntil({
        address,
        jwtValidUntil: date?.getTime() ?? 0,
      });
    }
  }, [signMessageData, date]);

  const handleSignMessage = async () => {
    let date = new Date(Date.now() + 1000 * 60 * 60 * 24);
    try {
      signMessage({
        account: address as `0x${string}`,
        message: `address: ${address} \nvalid until: ${new Date(date).toISOString()}`,
      });
      setDate(date);
      Analytics.confirmWalletEvent(address);
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    if (isConnecting) {
      audioManager.playSound(AUDIO_TYPES.CONFIRM_WALLET);
    }
  }, [isConnecting]);

  return (
    <InfoModal
      title={`${t('signModal.confirm')} ${t('signModal.ownership')}`}
      image={checklist}
      className="bg-black bg-opacity-75"
    >
      <p className="relative mb-4 self-stretch text-center text-md font-normal leading-5 text-white/80 md:mb-6 md:text-sm">
        {t('signModal.confirmText')}{' '}
        <span className="text-yellow-dark opacity-100">{address && address.slice(-4)}</span>
      </p>
      <p className="relative mb-4 self-stretch text-center text-md font-normal leading-[14px] text-light-grape md:mb-6">
        {t('signModal.free')}
      </p>
      <PrimaryButton className="w-full" text={'common.confirm'} onClick={handleSignMessage} />
    </InfoModal>
  );
});
